// Deployment config (VITE_BACKEND, VITE_TENANT_*, etc.) is injected at
// container start into window.__ENV__ (see index.html + deploy/docker/) so a
// single built image can be deployed to any environment. import.meta.env is
// only the source when window.__ENV__ isn't present, i.e. local/DDEV dev
// (npm run dev), where no entrypoint script runs.
export const getEnv = (key) => window.__ENV__?.[key] ?? import.meta.env[key];
